<template>
  <div class="modal-overlay" v-if="state.open">
    <div class="pgp-modal">
      <div class="pgp-modal-header">
        <font-awesome-icon :icon="faClose" @click="close" />
      </div>
      <div class="pgp-modal-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal-overlay {
  z-index: 2000;
  position: fixed !important;
  top: 0;
  height: 100%;
  width: 100%;
  background-color: rgb(0 0 0 / 0.5);
}

.pgp-modal {
  background-color: #fff;
  border-radius: 10px;
  position: relative;
  top: 100px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px;
  width: min(50em, 90%);
  max-height: 85vh;
}

.pgp-modal-header {
  width: 100%;
  height: 40px;
  text-align: right;
  vertical-align: middle;
  line-height: 45px;
  margin-top: -10px;
}
.pgp-modal-header > svg {
  cursor: pointer !important;
  font-size: 1.5rem;
}

.pgp-modal-content {
  display: flex;
  flex-direction: column;
  max-height: calc(85vh - 30px - 30px);
  overflow: hidden;
}

@media (max-width: 768px) {
  .pgp-modal {
    top: 10px;
    max-height: 97vh;
    height: 97vh !important;
  }

  .pgp-modal-content {
    max-height: calc(97vh - 40px - 40px);
  }
}
</style>

<script setup>
import { onBeforeUnmount, reactive } from "vue";
import { faClose } from "@fortawesome/free-solid-svg-icons";

const state = reactive({
  open: false,
});

const open = () => {
  state.open = true;
  document.documentElement.classList.add("modal-open");
};

const close = () => {
  state.open = false;
  document.documentElement.classList.remove("modal-open");
};

defineExpose({
  open,
  close,
});

onBeforeUnmount(() => {
  document.documentElement.classList.remove("modal-open");
});
</script>
